import { styled } from '@mui/material';

export const Wrapper = styled('div')({
    paddingBottom: '48px',
});
